import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon} from "@ionic/react"
import {refreshCircleOutline, refreshCircleSharp} from "ionicons/icons";

import {useTimeLimits} from "../../../contexts/TimeLimitContext"

import TimeLimit from "../../../types/TimeLimit"

interface componentProps {
    item: TimeLimit
}

const ButtonSync: React.FC<componentProps> = ({item}) => {

    const { t }  = useTranslation()
    const { inProgress, fetchItems, syncItem } = useTimeLimits()

    const handleSync = async () => {
        const newItem = await syncItem(item)

        if (newItem) {
            if (newItem.meta?.isUpdated) {
                fetchItems('', true)
            }
        }
    }

    return (
        <IonButton disabled={inProgress} type="button" color="bc-yellow" fill="outline"
                   className="ion-padding-start"
                   onClick={() => handleSync()}>
            <IonIcon slot="start" ios={refreshCircleOutline} md={refreshCircleSharp} />
            {t('common.synchronize')}
        </IonButton>
    )

}

export default ButtonSync